import { render, staticRenderFns } from "./FilterGlossaryPhases.vue?vue&type=template&id=14370fb8&scoped=true&"
import script from "./FilterGlossaryPhases.vue?vue&type=script&lang=js&"
export * from "./FilterGlossaryPhases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14370fb8",
  null
  
)

export default component.exports